export default "__VITE_ASSET__wM$AoyIQ__"